<template>
  <div class="traveler_detail_container">
    <div class="red">请填写出行人的有效证件信息。</div>
    <!-- <div class="red">请填写出行人的有效证件信息，以便签订电子旅游合同并购买保险。</div> -->
    <div class="traveler_content">
      <mt-field label="出行人姓名" placeholder="请输入出行人的姓名" v-model="postForm.nickname"/>
      <gender-field v-model="postForm.gender"/>
      <datetime-field label="出生日期" v-model="postForm.birthday"/>
      <cert-field v-model="postForm.cert_type"/>
      <mt-field label="证件号码" placeholder="请输入证件号码" v-model="postForm.cert"/>
    </div>

    <bottom-btn title="提交" @click.native="submitForm"/>
  </div>
</template>

<script>
import { Toast, Indicator } from 'mint-ui'
import bottomBtn from '@/components/common/bottomBtn.vue'
import genderField from '@/components/common/genderField.vue'
import certField from '@/components/common/certField.vue'
import datetimeField from '@/components/common/datetimeField.vue'
import { validateCert } from '@/utils/validation'
import { getTraveler, addTraveler, updateTraveler } from '@/api/traveler'

export default {
  name: 'traveler_detail',
  props: {
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      postForm: {
        nickname: '',
        gender: 1,
        cert_type: 1,
        cert: '',
        birthday: '',
        id: undefined
      }
    }
  },
  components: {
    genderField,
    certField,
    datetimeField,
    bottomBtn
  },
  created () {
    if (this.isEdit) {
      let id = this.$route.params && this.$route.params.id
      if (id) {
        this.getTraveler(id)
      } else {
        this.$router.replace('/travelers')
      }
    }
  },
  methods: {
    async getTraveler (id) {
      let response = await getTraveler(id)
      this.postForm = response.data
    },
    async submitForm () {
      if (!this.postForm.nickname) {
        Toast({ message: '出行人姓名不能为空', position: 'middle', duration: 3000 })
        return false
      }
      if (!this.postForm.cert) {
        Toast({ message: '出行人证件号码不能为空', position: 'middle', duration: 3000 })
        return false
      }
      if (this.postForm.cert_type === 1) {
        if (!validateCert(this.postForm.cert)) {
          Toast({ message: '证件号码输入有误', position: 'middle', duration: 3000 })
          return false
        }
      }

      let data = {
        nickname: this.postForm.nickname,
        gender: this.postForm.gender,
        birthday: this.postForm.birthday ? this.postForm.birthday + ' 00:00:00' : '',
        cert_type: this.postForm.cert_type,
        cert: this.postForm.cert
      }

      Indicator.open()
      let msg = ''
      if (this.isEdit) {
        data.id = this.postForm.id
        await updateTraveler(data)
        msg = '修改成功'
      } else {
        await addTraveler(data)
        msg = '添加成功'
      }
      Indicator.close()

      Toast({ message: msg, position: 'middle', duration: 1000 })

      setTimeout(() => {
        if (this.$route.query.from) {
          this.$router.push(this.$route.query.from)
        } else {
          this.$router.push('/travelers')
        }
      }, 1000)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  @import "@/assets/css/mixin.scss";
  .traveler_content {
    color: #333;
    margin-bottom: rem(80);
  }
  .red {
    padding: rem(10) rem(20) rem(20) rem(20);
    color: red;
  }
</style>
